<template>
    <div class="wpay-mypage">
        <!-- 3.22 화면 폼 자동제출 — 이니시스는 iframe 을 지원하지 않으므로 새창으로 띄운다 -->
        <form ref="form" :action="url" method="post" :target="target" style="display: none">
            <input v-for="(value, key) in params" :key="key" type="hidden" :name="key" :value="value" />
        </form>
        <v-btn small outlined color="primary" v-bind="{ loading }" @click="open">
            <v-icon small left>mdi-cog-outline</v-icon> KG이니시스 결제계좌 관리
        </v-btn>
    </div>
</template>

<script>
import api from "@/api";
import { listenParent, clearChannel, isMobileBrowser } from "@/plugins/pg-result-bridge";

// 쿠콘 결제창은 창 안 톱니바퀴로 계좌를 관리하지만, 이니시스는 결제창에 비밀번호 변경만 있고
// 계좌 등록·삭제·회원탈퇴는 "회원설정 마이페이지"(가이드 3.22)라는 별도 화면에서 한다.
// 이 버튼이 그 화면을 새창으로 연다 (2026-09-09 현장 피드백).
const TARGET = "wpayMyPagePopup";
const FEATURES = "width=500,height=700,resizable=yes,scrollbars=yes";
const CHANNEL = "wpay-mypage";

export default {
    data() {
        return { url: null, params: {}, target: TARGET, popup: null, loading: false, dispose: null };
    },
    mounted() {
        // 회원탈퇴 후 result.vue(kind=mypage)가 알린다. www 유무가 달라도 닿도록 브리지로 듣는다.
        window.wpayMyPageComplete = (payload) => this.onComplete(payload);
        this.dispose = listenParent(CHANNEL, (payload) => this.onComplete(payload));
    },
    beforeDestroy() {
        window.wpayMyPageComplete = undefined;
        this.dispose?.();
    },
    methods: {
        async open() {
            if (this.loading) return;
            clearChannel(CHANNEL);

            // 모바일은 팝업 대신 같은 탭으로 간다(iOS 사파리 팝업 차단·새 탭 문제). 탈퇴하면 결과 페이지가 구매 화면으로 돌려보낸다.
            const mobile = isMobileBrowser();
            this.target = mobile ? "_self" : TARGET;

            // 팝업 차단기는 클릭에서 곧바로 이어진 창만 허용한다 — 요청 전에 빈 창부터 잡는다.
            if (!mobile) {
                this.popup = window.open("", TARGET, FEATURES);
                if (!this.popup) return alert("팝업이 차단되어 있습니다. 팝업 차단을 해제한 뒤 다시 시도해주세요.");
            }

            this.loading = true;
            try {
                const { checkout } = await api.plugins.wpay.mypage.request();
                this.url = checkout.url;
                this.params = checkout.params;
                await this.$nextTick();
                this.$refs.form.submit();
                this.popup?.focus?.();
            } catch (error) {
                try { this.popup?.close(); } catch (e) { /* 무시 */ }
                this.popup = null;
                alert(error?.response?.data?.message || error.message);
            } finally {
                this.loading = false;
            }
        },
        onComplete(payload = {}) {
            try { if (this.popup && !this.popup.closed) this.popup.close(); } catch (error) { /* 다른 출처면 닫지 못할 수 있다 */ }
            this.popup = null;
            this.$emit("complete", payload);
            if (payload.resMessage) alert(payload.resMessage);
        },
    },
};
</script>
